import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToAccessDocument: {
        id: 'portal.views.policy-document-error.Unable to access document',
        defaultMessage: 'Apologies: we are unable to access your policy documents at this time. Please try again later.',
    }
});
